module.exports = __webpack_public_path__ + "img/charity_box.37be7a40.svg";